<app-base-modal
  [title]="getTitleModal()"
  [showStateToggle]="isValid"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div
    class="content"
    cdkDropList
    cdkDropListOrientation="mixed"
    (cdkDropListDropped)="handleDrop($event)"
  >
    @if (isActiveEditor) {
      <div
        app-mb-editor
        [marketingBlockData]="marketingBlocksData[selectIndex]"
        [marketingBlockFormGroup]="marketingBlockFormGroups[selectIndex]"
        [parentId]="baseMarketingBlockDialogData.parentId"
        [isEditModeActive]="isEditModeActive"
        [columnKey]="baseMarketingBlockDialogData.modalKey"
        [noFirstData]="noFirstData"
        [isActiveEditor]="isActiveEditor"
        (updateMarketingBlock)="updateMarketingBlockData($event, selectIndex)"
        (backClick)="backClick()"
      ></div>
    } @else {
      @for (marketingBlock of marketingBlocksData; track $index) {
        <div
          class="marketing-block-item"
          cdkDrag
          [cdkDragDisabled]="!isActiveDragAndDrop()"
        >
          @if (isActiveDragAndDrop()) {
            <mat-icon
              class="marketing-block-icon"
              cdkDragHandle
            >
              drag_indicator
            </mat-icon>
          }
          <div
            class="row"
            app-mb-form
            [marketingBlockData]="marketingBlock"
            [marketingBlockFormGroup]="marketingBlockFormGroups[$index]"
            [parentId]="baseMarketingBlockDialogData.parentId"
            [isEditModeActive]="isEditModeActive"
            [columnKey]="baseMarketingBlockDialogData.modalKey"
            [noFirstData]="noFirstData"
            [isActiveEditor]="isActiveEditor"
            (updateMarketingBlock)="updateMarketingBlockData($event, $index)"
            (deleteMarketingBlock)="deleteMarketingBlockData($index)"
            (activeEditor)="activeEditor($index)"
          ></div>
        </div>
      }
    }
  </div>
  @if (!isActiveEditor) {
    <div class="row-bottom">
      <button
        mat-mini-fab
        class="row-btn-add"
        [disabled]="!isValid"
        (click)="handleAddNew()"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  }
</app-base-modal>
